import type { ButtonPriority } from '@timelyapp/react';
import { Button } from '@timelyapp/react';
import PopoverDropdownList from 'components/popovers/PopoverDropdownList';
import React from 'react';
import type { RateType } from 'types/project';

const STATES: Array<RateType | 'any'> = ['any', 'project', 'user', 'non-billable'];
type RateTypeState = (typeof STATES)[number];
const valueLabelMapping: Record<RateTypeState, string> = {
  any: 'Any type',
  user: 'Individual rate',
  project: 'Project rate',
  'non-billable': 'Non-billable projects',
};

interface Props {
  value: RateType | null;
  onChange: (value: RateType | null) => void;
  buttonPriority?: ButtonPriority;
}

const RateTypeDropdown = (props: Props) => {
  const options = STATES.map(state => ({ name: valueLabelMapping[state], id: state }));
  const handleChange = (option: (typeof options)[number]) => {
    props.onChange(option.id === 'any' ? null : option.id);
  };
  return (
    <PopoverDropdownList
      onClick={handleChange}
      options={options}
      targetCaret={true}
      target={
        <Button priority={props.buttonPriority ?? 'low'}>
          {valueLabelMapping[props.value ?? 'any']}
        </Button>
      }
    />
  );
};

export default RateTypeDropdown;
